<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M32 0h-3.971l-1.654.827L24.721 0h-7.784l-1.875.938H9.88L8.005 0H0v15.063l.938 1.875v5.182L0 23.995V32h16l1.654-.827 1.654.827h12.693V19.307l-.827-1.654.827-1.654zM8.438 26.375l-2.813-2.813v-5.625l8.438 8.438zm17 0h-3.75l-2.43-2.856-.501-2.035-1.929-.82L5.626 7.501l1.875-1.875 18.875 14.187zm.937-12.312-8.438-8.438h5.625l2.813 2.813z"
	/>
</svg>
